/**
 * Detail page.
 */
import DetailTemplate from '@components/templates/detail';
import useDetail from '@components/pages/detail/useDetail';

/**
 * Displays an event detail page.
 * Retrieves the properties and injects them into the template.
 */
export default function DetailPage() {
  const props = useDetail();
  return <DetailTemplate {...props} />;
}
